import { render, staticRenderFns } from "./PermissionList.vue?vue&type=template&id=8b30d642"
import script from "./PermissionList.vue?vue&type=script&lang=ts"
export * from "./PermissionList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports